/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/
// React
import React from "react";
// form library
import { Controller, useFormContext } from 'react-hook-form';
// material ui components
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
// custom components
import LeadNumberedHeading from "../../../../shared-components/forms/LeadNumberedHeading";
import NumberedHeading from "../../../../shared-components/forms/NumberedHeading";
import TemplateSelect from "./selects/TemplateSelect";


function TemplateTab(props) {
  const methods = useFormContext();
  const { control, formState, setValue } = methods;
  const { errors } = formState;

  const { template } = props;

  return (
    <div>
      <LeadNumberedHeading number="4" title="Development Information" instructions="This information is used to store content from a page template. Please select a template and fill out the form completely." />

      {!template ? (
        <div className="flex flex-1 items-center justify-center min-h-320">
          <Typography color="text.secondary">
            Please select a template to continue...
          </Typography>
        </div>
      ) : (
        <div className="mt-32">
          <Accordion
            className="bg-transparent shadow-none border-b-1 border-t-0"
            sx={{
              [`&:before`]: {
                display: 'none'
              },
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              className="px-0 border-0"
            >
              <Typography variant="subtitle2" className="font-semibold">
                Branching:
              </Typography>
            </AccordionSummary>
            <AccordionDetails
              className="px-0"
            >
              <Typography
                variant="body2"
                dangerouslySetInnerHTML={{ __html: template.branching }}
                sx={{
                  [`& ul, & ol`]: {
                    listStyle: "auto",
                    margin: "revert",
                    padding: "revert",
                  },
                }}
              />
            </AccordionDetails>
          </Accordion>

          <Accordion
            className="bg-transparent shadow-none border-b-1 border-t-0"
            sx={{
              [`&:before`]: {
                display: 'none'
              },
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              className="px-0"
            >
              <Typography variant="subtitle2" className="font-semibold">
                Programming Notes:
              </Typography>
            </AccordionSummary>
            <AccordionDetails
              className="px-0"
            >
              <Typography
                variant="body2"
                dangerouslySetInnerHTML={{ __html: template.dev_notes }}
                sx={{
                  [`& ul, & ol`]: {
                    listStyle: "auto",
                    margin: "revert",
                    padding: "revert",
                  },
                }}
              />
            </AccordionDetails>
          </Accordion>

          <Accordion
            className="bg-transparent shadow-none border-b-1 border-t-0"
            sx={{
              [`&:before`]: {
                display: 'none'
              },
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              className="px-0"
            >
              <Typography variant="subtitle2" className="font-semibold">
                Graphic Artist Notes:
              </Typography>
            </AccordionSummary>
            <AccordionDetails
              className="px-0"
            >
              <Typography
                variant="body2"
                dangerouslySetInnerHTML={{ __html: template.ga_notes }}
                sx={{
                  [`& ul, & ol`]: {
                    listStyle: "auto",
                    margin: "revert",
                    padding: "revert",
                  },
                }}
              />
            </AccordionDetails>
          </Accordion>

          <Accordion
            className="bg-transparent shadow-none border-b-1 border-t-0"
            sx={{
              [`&:before`]: {
                display: 'none'
              },
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              className="px-0"
            >
              <Typography variant="subtitle2" className="font-semibold">
                508 Compliance Plan:
              </Typography>
            </AccordionSummary>
            <AccordionDetails
              className="px-0"
            >
              <Typography
                variant="body2"
                dangerouslySetInnerHTML={{ __html: template.accessibility }}
                sx={{
                  [`& ul, & ol`]: {
                    listStyle: "auto",
                    margin: "revert",
                    padding: "revert",
                  },
                }}
              />
            </AccordionDetails>
          </Accordion>

          <Accordion
            className="bg-transparent shadow-none border-b-1 border-t-0"
            sx={{
              [`&:before`]: {
                display: 'none'
              },
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              className="px-0"
            >
              <Typography variant="subtitle2" className="font-semibold">
                Additional Information:
              </Typography>
            </AccordionSummary>
            <AccordionDetails
              className="px-0"
            >
              <Typography
                variant="body2"
                dangerouslySetInnerHTML={{ __html: template.info }}
                sx={{
                  [`& ul, & ol`]: {
                    listStyle: "auto",
                    margin: "revert",
                    padding: "revert",
                  },
                }}
              />
            </AccordionDetails>
          </Accordion>         
        </div>
      )}
    </div>
  );
}

export default TemplateTab;